import { render, staticRenderFns } from "./WarrantedFilter.vue?vue&type=template&id=1b1348c0&scoped=true"
import script from "./WarrantedFilter.vue?vue&type=script&lang=ts"
export * from "./WarrantedFilter.vue?vue&type=script&lang=ts"
import style0 from "./WarrantedFilter.vue?vue&type=style&index=0&id=1b1348c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1348c0",
  null
  
)

export default component.exports